/*
 * RecentPage Messages
 *
 * This contains all the text for the RecentPage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.Recent';

export default defineMessages({
  pageTitle: {
    id: `${scope}.page.title`,
    defaultMessage: 'Workspace',
  },
  pageDescription: {
    id: `${scope}.page.description`,
    defaultMessage: 'CDP Workspace',
  },
  recent: {
    id: `${scope}.page.recent`,
    defaultMessage: 'Recent',
  },
  recentEmptyMessage1: {
    id: 'recentEmptyMessage1',
    defaultMessage: 'No courses to show yet. Your courses will',
  },
  recentEmptyMessage2: {
    id: 'recentEmptyMessage2',
    defaultMessage: 'appear here after you create or access',
  },
  recentEmptyMessage3: {
    id: 'recentEmptyMessage3',
    defaultMessage: 'them',
  },
  recentErrorMessage1: {
    id: 'recentErrorMessage1',
    defaultMessage: 'There was a problem downloading content.',
  },
  recentErrorMessage2: {
    id: 'recentErrorMessage2',
    defaultMessage: 'Please try again later.',
  },
});
